export default __webpack_public_path__ + "static/media/edge-icon.562ce052.svg";